import { Injectable } from "@angular/core";
import { ITradeDealService, CHANNEL_TRADE_SERVICE } from "../ITradeDealService";
import { ENCODABLE_TYPE_ERRORS } from "shared/broker-client-services";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import { Subject } from "rxjs";
import { TradeDeal } from "../../model/core/TradeDeal";
import { TradeRate } from "../../model/core/TradeRate";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class TradeDealReplicaService implements ITradeDealService {
  protected broker: ClientMessageBroker;

  constructor(protected factory: ClientMessageBrokerFactory) {
    this.broker = this.factory.createMessageBroker(CHANNEL_TRADE_SERVICE, true, true);
  }

  public confirmTradeDeal(deal: TradeDeal): Promise<any> {
    let request = new UiArguments("confirmTradeDeal");
    let arg1 = new FnArg(deal, PRIMITIVE);
    request.args = [arg1];
    return this.runOnService(request);
  }

  public confirmTradeDeals(deals: Array<TradeDeal>): Promise<any> {
    let request = new UiArguments("confirmTradeDeal");
    let arg1 = new FnArg(deals, PRIMITIVE);
    request.args = [arg1];
    return this.runOnService(request);
  }

  public cancelTradeDeal(deal: TradeDeal): Promise<any> {
    let request = new UiArguments("cancelTradeDeal");
    let arg1 = new FnArg(deal, PRIMITIVE);
    request.args = [arg1];
    return this.runOnService(request);
  }

  public cancelTradeDeals(deals: Array<TradeDeal>): Promise<any> {
    let request = new UiArguments("cancelTradeDeals");
    let arg1 = new FnArg(deals, PRIMITIVE);
    request.args = [arg1];
    return this.runOnService(request);
  }
  public addFillComment(deal: TradeDeal, comment: string): Promise<any> {
    let request = new UiArguments("addFillComment");
    let arg1 = new FnArg(deal, PRIMITIVE);
    let arg2 = new FnArg(comment, PRIMITIVE);
    request.args = [arg1, arg2];
    return this.runOnService(request);
  }

  public getTradeDeals(dealIds: Array<string>): Promise<Array<TradeDeal>> {
    let request = new UiArguments("getTradeDeals");
    let arg1 = new FnArg(dealIds, PRIMITIVE);
    request.args = [arg1];
    return this.runOnService(request, new Array<TradeDeal>());
  }

  public getTradeDealDetails(
    dealId: string,
    includeDetails: boolean,
    includeConfirmations: boolean,
  ): Promise<TradeDeal> {
    let request = new UiArguments("getTradeDealDetails");
    let arg1 = new FnArg(dealId, PRIMITIVE);
    let arg2 = new FnArg(includeDetails, PRIMITIVE);
    let arg3 = new FnArg(includeConfirmations, PRIMITIVE);
    request.args = [arg1, arg2, arg3];
    return this.runOnService(request, PRIMITIVE);
  }

  protected runOnService(request: UiArguments, assignable: any = null): Promise<any> {
    return new Promise<any>((res, rej) => {
      this.broker.runOnService(request, PRIMITIVE).then((value: any) => {
        if (value && value.enType && value.enType == ENCODABLE_TYPE_ERRORS) {
          rej(value);
        } else {
          if (assignable && value) {
            value = Object.assign(assignable, value);
          }
          res(value);
        }
      });
    });
  }
}
